module.exports = __webpack_public_path__ + "img/5.67e37126.jpg";